module.exports = __webpack_public_path__ + "media/application/images/2023/07_still-925x520-51184a534f4bb12c4e08a3011470f6cc.png";